/**
 * Stub ChatbotInitializer for backward compatibility with legacy workspaces.
 * Smooch has been removed - these methods are now no-ops.
 * Legacy workspaces (Account, Contacts, History, Products, Mail) still call
 * logout() and resetChatMessengerUserPrefs() on signout.
 */
export default class ChatbotInitializer {
	/**
	 * No-op: Smooch removed, Sierra cleanup handled by SierraInitializer
	 */
	static logout = () => {
		// Intentionally empty - smooch removed
	};

	/**
	 * No-op: Smooch user preferences no longer exist
	 */
	static resetChatMessengerUserPrefs = () => {
		// Intentionally empty - smooch removed
	};
}
